'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _chemist = require('chemist');

var _FormInput = require('../../../FormInput');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shape = _react.PropTypes.shape,
    string = _react.PropTypes.string,
    func = _react.PropTypes.func;
var AddressBookEdit = (_dec = (0, _reactRedux.connect)(function (state) {
  return { postcodeError: state.addressBook.postcodeError };
}), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _chemist.configurable)(), _dec4 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AddressBookEdit, _React$Component);

  function AddressBookEdit() {
    (0, _classCallCheck3.default)(this, AddressBookEdit);
    return (0, _possibleConstructorReturn3.default)(this, (AddressBookEdit.__proto__ || (0, _getPrototypeOf2.default)(AddressBookEdit)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressBookEdit, [{
    key: 'formErrors',
    value: function formErrors() {
      if (this.props.postcodeError) {
        return { AddressBookPostcode: ['is invalid'] };
      }

      return {};
    }
  }, {
    key: 'renderCompanyField',
    value: function renderCompanyField() {
      var _props = this.props,
          t = _props.t,
          address = _props.address;


      return _react2.default.createElement(
        _FormInput.Field,
        { inputName: 'AddressBookCompany', inputLabel: t('spree.company') },
        _react2.default.createElement(_FormInput.Input, {
          defaultValue: address.company,
          name: 'AddressBookCompany'
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          address = _props2.address,
          config = _props2.config;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Change address'
        ),
        _react2.default.createElement(
          _FormInput.Fieldset,
          null,
          _react2.default.createElement(_FormInput.Input, { type: 'hidden', name: 'AddressBookId', defaultValue: address.id }),
          config.theme === 'painters' && this.renderCompanyField(),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookFirstName', inputLabel: t('spree.first_name'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, {
              defaultValue: address.firstName,
              name: 'AddressBookFirstName',
              required: true
            })
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookLastName', inputLabel: t('spree.last_name'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, {
              defaultValue: address.lastName,
              name: 'AddressBookLastName',
              required: true
            })
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookAddressLine1', inputLabel: t('spree.address1'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, {
              defaultValue: address.address1,
              name: 'AddressBookAddressLine1',
              required: true
            })
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookAddressLine2', inputLabel: t('spree.address2') },
            _react2.default.createElement(_FormInput.Input, {
              defaultValue: address.address2,
              name: 'AddressBookAddressLine2'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-6' },
              _react2.default.createElement(
                _FormInput.Field,
                { inputName: 'AddressBookCity', inputLabel: t('spree.city'), fieldRequired: true },
                _react2.default.createElement(_FormInput.Input, {
                  defaultValue: address.city,
                  name: 'AddressBookCity',
                  required: true
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-6' },
              _react2.default.createElement(
                _FormInput.Field,
                {
                  inputName: 'AddressBookPostcode',
                  inputLabel: t('spree.zipcode'),
                  errors: this.formErrors(),
                  fieldRequired: true
                },
                _react2.default.createElement(_FormInput.Input, {
                  defaultValue: address.postcode,
                  name: 'AddressBookPostcode',
                  required: true
                })
              )
            )
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookState', inputLabel: t('spree.state'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, {
              defaultValue: address.state,
              name: 'AddressBookState',
              required: true
            })
          ),
          _react2.default.createElement(
            _FormInput.Field,
            { inputName: 'AddressBookPhone', inputLabel: t('spree.phone'), fieldRequired: true },
            _react2.default.createElement(_FormInput.Input, {
              defaultValue: address.phone,
              name: 'AddressBookPhone',
              placeholder: '0123456789',
              required: true,
              type: 'tel',
              pattern: '^[\\d\\s]+$'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'button-bar' },
          _react2.default.createElement(
            _FormInput.Button,
            {
              type: 'button',
              styleName: 'button-cancel',
              weight: 'quaternary',
              onClick: this.props.onCancel
            },
            'Cancel'
          ),
          _react2.default.createElement(
            _FormInput.Button,
            { styleName: 'button-save' },
            'Save'
          )
        )
      );
    }
  }]);
  return AddressBookEdit;
}(_react2.default.Component), _class2.propTypes = {
  onCancel: func.isRequired,
  address: shape({
    id: string.isRequired,
    firstName: string.isRequired,
    lastName: string.isRequired,
    company: string.isRequired,
    address1: string.isRequired,
    address2: string.isRequired,
    city: string.isRequired,
    state: string.isRequired,
    postcode: string.isRequired
  })
}, _temp)) || _class) || _class) || _class) || _class);
exports.default = AddressBookEdit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressBookEdit/index.js
// module id = 2255
// module chunks = 0